module.exports = __webpack_public_path__ + "img/설선물.6e80f8b7.png";